import PropTypes from 'prop-types'
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Text,
} from '@chakra-ui/react'
import {useFormik} from 'formik'
import * as Yup from 'yup'
import {useTranslation} from 'react-i18next'
import {Alert} from '../..'

const validationSchema = Yup.object().shape({
  name: Yup.string().required('Please enter an expense account name'),
  description: Yup.string().required(
    'Please enter an expense account description',
  ),
})

const CreateForm = ({onSubmit, hideFields, error}) => {
  const {t} = useTranslation('connectExpenseAccount')

  const formik = useFormik({
    initialValues: {
      name: t('form.fields.create.defaultValue'),
      description: t('form.fields.description.defaultValue'),
    },
    validationSchema,
    onSubmit: async (values) => {
      await onSubmit(values)
    },
  })

  return (
    <form id="create-expense-account-form" onSubmit={formik.handleSubmit}>
      {error && (
        <Alert
          status="error"
          message={
            <Box display="flex" flexDirection="column">
              <Text textStyle="body-small" color="red.500">
                {error}
              </Text>
            </Box>
          }
          mb={8}
        />
      )}
      <Flex flexDirection="column" gap={4}>
        <FormControl
          hidden={hideFields}
          isInvalid={Boolean(formik.touched.name && formik.errors.name)}
        >
          <FormLabel htmlFor="name">
            <Text fontSize="sm" fontWeight="medium">
              {t('form.fields.create.label')}
            </Text>
          </FormLabel>
          <Input
            id="name"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
          />
          <FormErrorMessage>{formik.errors.name}</FormErrorMessage>
        </FormControl>
      </Flex>
    </form>
  )
}

CreateForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  hideFields: PropTypes.bool,
  error: PropTypes.string,
}

CreateForm.defaultProps = {
  hideFields: false,
  error: null,
}

export default CreateForm
